import { GoogleApiAccountQuery } from './__generated__/GoogleApiAccountQuery';
import { useQuery } from '@apollo/react-hooks';
import { kmsClient } from '../../apollo';
import { GOOGLE_API_ACCOUNT_QUERY } from './googleApiAccount.query';

export const useGoogleApiAccountQuery = () =>
  useQuery<GoogleApiAccountQuery>(GOOGLE_API_ACCOUNT_QUERY, {
    client: kmsClient
  });
